<div *ngIf="video()?.host_identifier" class="embed-responsive embed-responsive-16by9 {{classes}}" style="padding:56.25% 0 0 0;position:relative;">
    <iframe
        [src]="iframeSrc"
        frameborder="0"
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        allow="autoplay; fullscreen; picture-in-picture;"
        title="{{video().name}}">
    </iframe>
</div>
<!-- <script src="https://player.vimeo.com/api/player.js"></script> -->